// Global Instructions Rule Applied!

import { FundState } from '../../interfaces/funds.ts'
import { FundRecordFields } from '../../data_models/fund_record.ts'

/**
 * Find a fund by ID in the funds.data array.
 * Returns undefined if not found.
 *
 * Mirrors selectCompanyById / selectDealById for consistency. The full-form
 * tab-title fallback chain prefers activeRecords first, then this selector.
 */
export const selectFundById = (
  state: { funds: FundState },
  fundId: string | number | null | undefined
) => {
  if (!fundId || !state.funds) return undefined

  const fundIdString = fundId.toString()

  return state.funds.data.find(
    (fund) => (fund as any)[FundRecordFields.funds__id]?.toString() === fundIdString
  )
}
